import { render, staticRenderFns } from "./ModelTags.vue?vue&type=template&id=56d36f8a&scoped=true"
import script from "./ModelTags.vue?vue&type=script&lang=js"
export * from "./ModelTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d36f8a",
  null
  
)

export default component.exports